<template>
  <div class="container">
    <div v-if="error">
      <p><em>An error occurred in loading images:</em></p>
      <p>{{ errorMessage }}</p>
      <p>
        <b-button @click="netLoadImages(true)">
          <b-icon-arrow-counterclockwise aria-hidden="true"></b-icon-arrow-counterclockwise>
          Retry
        </b-button>
        or try again later.
      </p>
    </div>
    <div v-if="!error && (!customimages || customimages.length === 0)">
      <p>No previously uploaded images.</p>
      <p v-if="!config.user">
        If you have an account,
        <a :href="config.loginURL">sign in</a> to access existing saved designs.
      </p>
    </div>
    <ImageThumb
        v-for="ci in customimages" :key="ci.key"
        :imgkey="ci.key"
        :path="ci.path"
        :idx="idx">
    </ImageThumb>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import axios from 'axios';
import { BIconArrowCounterclockwise } from 'bootstrap-vue';

import ImageThumb from '@/components/ImageThumb.vue';

export default {
  name: 'ImageExisting',
  components: {
    ImageThumb,
    BIconArrowCounterclockwise,
  },
  props: {
    idx: Number,
  },
  data() {
    return {
      customimages: [],
      error: null,
    };
  },
  computed: {
    errorMessage() {
      let errmsg = 'An unknown error occurred.';
      if (this.error.request) {
        console.log(this.error.request);
        errmsg = `${this.error.response.statusText} (${this.error.response.status})`;
      } else if (this.error.response) {
        console.log(this.error.response);
        errmsg = 'Could not contact the server.';
      } else {
        console.log(this.error.message);
        errmsg = `An unknown error occurred: ${this.error.message}`;
      }
      return errmsg;
    },
    ...mapState(['config']),
  },
  methods: {
    netLoadImages(toast = false) {
      console.log(this.config.imagesListURL);
      axios.get(this.config.imagesListURL)
        .then((response) => {
          this.customimages = response.data;
          this.error = null;
          console.log('customimages', this.customimages);
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
          if (toast) {
            this.$bvToast.toast(
              this.errorMessage,
              {
                title: 'Load Images Error',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 12000,
                variant: 'danger',
                solid: true,
              },
            );
          }
        });
    },
  },
  mounted() {
    this.netLoadImages();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
   height: 55vh;
   overflow-y: scroll;
}

.thumb {
  display: inline-block;
}

.thumb img {
  box-sizing: content-box;
  border-width: medium;
  border-style: solid;
  border-color: #00000000;
}
</style>
